// We need to initialize common page elements,
// as this entrypoint isn't initialized by the main application.js
import "entry/common"

import currentRegion from "lib/currentRegion"
import rememberRegion from "lib/rememberRegion"
import localStorageCheck from "lib/localStorageCheck"
import renderPromos from "promos/renderPromos"
import getUserDataWhileRevalidate from "promos/getUserDataWhileRevalidate"
import { initializeCommonPageElements } from "pages/common"

async function initialize() {
  const region = await currentRegion().catch(() => "no-region")

  initializeCommonPageElements()
  rememberRegion()

  const storage = localStorageCheck() ? window.localStorage : undefined
  let user
  const userLoaded = new Promise((resolved) => {
    user = getUserDataWhileRevalidate(storage, resolved)
  })

  const signal = await renderPromos({
    region,
    user: {
      donations: user.donations,
    },
  })

  userLoaded.then((user) => signal.next({ type: "donationsLoaded", donations: user.donations }))
}

// Now, let's export the entrypoint initializer, so it's available for the
// `js_page` ERB yield block
TC.EntrypointInitializer = initialize
